import { compose } from 'recompose';
import FormGroup from './formWrapper';

const enhance = compose();
export default enhance(FormGroup);
